import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, computed } from 'vue';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  NavBar,
  LoaderIndicator,
  HelperViewStatus,
  Heading,
  BaseText,
  InitialAvatarIcon,
  ChipStatus
} from '@warrenbrasil/nebraska-web';
import { SideSheet } from '@/modules/common/components/SideSheet';
import { BackButton } from '@/modules/common/components/buttons';
import { ProductOrderDetails, PortfolioOrderDetails } from './components';

import {
  getPendingOrders,
  IPendingOrder,
  IOrder,
  EOrderType
} from '@/modules/home/services/orders';

interface Props {
  isOpen: boolean;
  orderType: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PendingOrdersSheet',
  props: {
    isOpen: { type: Boolean },
    orderType: null
  },
  setup(__props: any) {

const props = __props as {
  isOpen: boolean;
  orderType: string;
};



const pendingOrders = ref<IPendingOrder | null>(null);
const isLoading = ref(false);
const hasError = ref(false);

const selectedOrder = ref<IOrder | null>(null);
const isProductDetailsOpen = ref(false);
const isPortfolioDetailsOpen = ref(false);

watch(
  () => props.isOpen,
  async isOpen => {
    if (isOpen) {
      fetchPendingOrders();
    }
  },
  { immediate: true }
);

const orderId = computed(() => selectedOrder.value?.id || '');
const productType = computed(() => selectedOrder.value?.productType || '');
const portfolioType = computed(() => selectedOrder.value?.portfolioType || '');

function openDetails(order: IOrder) {
  selectedOrder.value = order;

  if (order.orderType === EOrderType.PORTFOLIO) {
    isPortfolioDetailsOpen.value = true;
  } else {
    isProductDetailsOpen.value = true;
  }
}

async function fetchPendingOrders() {
  try {
    isLoading.value = true;
    hasError.value = false;

    pendingOrders.value = await getPendingOrders(props.orderType);
  } catch {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

return { __sfc: true,props, pendingOrders, isLoading, hasError, selectedOrder, isProductDetailsOpen, isPortfolioDetailsOpen, orderId, productType, portfolioType, openDetails, fetchPendingOrders, NebraskaColors, NavBar, LoaderIndicator, HelperViewStatus, Heading, BaseText, InitialAvatarIcon, ChipStatus, SideSheet, BackButton, ProductOrderDetails, PortfolioOrderDetails }
}

})